module.exports = __webpack_public_path__ + "img/eritrea.fbee658b.svg";